import React from 'react';
import { Container } from 'react-bootstrap';

const DisclaimerPage = () => {
  return (
    <Container className="py-5">
      <div className="mx-auto" style={{ maxWidth: '900px' }}>
        <h1 className="text-center mb-4">Disclaimer</h1>

        <p>
          All text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations,
          and software and protected by United States and international copyright laws. The developer/builder/owner
          reserves the right in its sole discretion to make changes or modifications to maps, plans, specifications,
          materials, features and colors without notice.
        </p>

        <p>
          No portion of this website — inclusive of, but not limited to, design elements, photos, coding, and
          look &amp; feel — may be used or reproduced by any means without the express written consent of
          Spherexx.com. Photos, images and other 3rd party licensing provided by Spherexx.com or the website
          owner is licensed to this domain only and cannot be reproduced in any form without additional
          licensing fees.
        </p>

        <p>
          All trademarks herein are the property of their respective owners who have all the rights therein.
          In addition, graphics, logos, page headers, button icons, scripts are trademarks. No trademarks or
          service marks may be used or reproduced without the express written consent of their respective owners.
        </p>
      </div>
    </Container>
  );
};

export default DisclaimerPage;